import { fireOperationalAnalytics } from '@atlassian/jira-product-analytics-bridge';
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import { batch } from '../../../../common/utils';
import { fetchExternalLinkIcon as fetchExternalLinkIconService } from '../../../../services/external-link-icon-fetch-service';
import type { State, Props } from '../../types';

export const EVENT_NAME = 'externalResourceIconFetch';

const batchedFetchExternalLinkIconService = batch(fetchExternalLinkIconService, 0);
export const fetchExternalLinkIcon =
	(linkOrigin: string) =>
	async ({ getState, setState }: StoreActionApi<State>, props: Props) => {
		const { createAnalyticsEvent } = props;
		try {
			let state = getState();
			if (Object.keys(state.icons).includes(linkOrigin)) {
				return state.icons[linkOrigin];
			}

			setState({
				...state,
				icons: {
					...state.icons,
					[linkOrigin]: {
						iconUrl: null,
						isLoading: true,
					},
				},
			});

			const resolvedObject = await batchedFetchExternalLinkIconService(linkOrigin);
			const iconUrl = resolvedObject[linkOrigin].body?.data?.generator?.icon?.url;
			const linkIconObject = {
				iconUrl,
				isLoading: false,
			};
			state = getState();
			setState({
				...state,
				icons: {
					...state.icons,
					[linkOrigin]: linkIconObject,
				},
			});

			fireOperationalAnalytics(createAnalyticsEvent({}), `${EVENT_NAME} succeeded`, {
				isIconPresent: Boolean(iconUrl),
			});
			return linkIconObject;
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (error: any) {
			fireOperationalAnalytics(createAnalyticsEvent({}), `${EVENT_NAME} failed`);
			const linkIconObject = {
				iconUrl: null,
				isLoading: false,
			};
			const state = getState();

			setState({
				...state,
				icons: {
					...state.icons,
					[linkOrigin]: linkIconObject,
				},
			});
			return linkIconObject;
		}
	};
